




import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import Smartmap from '@/modules/map/_components/Smartmap.vue';

@Component({
  components: {
    Smartmap,
  },
})
export default class Home extends Vue {
  @Action('auth/initAnonymous') private initAnonymous!: any;
  @Action('auth/initUser') private initUser!: any;
  @Action('common/loader/start') private startLoader!: any;
  @Action('common/loader/stop') private stopLoader!: any;
  @Action('map/startQuickCatchment') private startQuickCatchment!: any;
  @Action('map/stopQuickCatchment') private stopQuickCatchment!: any;

  @Getter('auth/loggedIn') private loggedIn!: boolean;
  @Getter('map/quickCatchment') private quickCatchment!: any;

  private loading: boolean = true;

  private async mounted() {
    this.startLoader();
    if (!this.loggedIn) {
      await this.initAnonymous();
    } else {
      await this.initUser();
    }
    this.loading = false;
    this.stopLoader();
  }

}
